import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { reportsOverviewPageEntryPoint as reportsOverviewPageEntry } from '@jira/software__reports-overview-page/src/reportsOverviewPageEntryPoint.entrypoint.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { getProjectViewResources } from '@jira/router-resources__business-common/src/getBusinessProjectResources.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { AsyncHorizontalNavJira } from '@jira/navigation-apps__horizontal-nav-jira/src/async.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { businessProjectLayout } from '@jira/platform__layouts-business-project-layout/src/index.tsx';
import { ThemedLazySkeleton } from '@jira/platform__project-theme-components/src/ui/ThemedLazySkeleton.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { jiraBusinessReportsOverviewRoute } from '@jira/router-routes__business-reports-routes/src/jiraBusinessReportsOverviewRoute.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { jiraHorizontalNavEntrypoint } from '@jira/navigation-apps__horizontal-nav-jira/src/jiraHorizontalNavEntrypoint.entrypoint.tsx';
import type { Route } from '@atlassian/react-resource-router';

const reportsOverviewPageEntryPoint = createPageEntryPoint({
	main: reportsOverviewPageEntry,
	horizontalNavigation: jiraHorizontalNavEntrypoint,
});

export const jiraBusinessReportsOverviewRouteEntry: Route = createEntry(
	jiraBusinessReportsOverviewRoute,
	() => ({
		group: 'classic-business',
		ufoName: 'jwm.reports-overview',

		entryPoint() {
			return reportsOverviewPageEntryPoint;
		},

		layout: businessProjectLayout,
		skeleton: ThemedLazySkeleton,

		navigation: {
			menuId: MenuIdProjects,
			horizontal: AsyncHorizontalNavJira,
		},

		resources: getProjectViewResources(),

		supportsProjectTheme: fg('enable_avp_jira_summary_page') ? 'contoured' : 'full',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
